import * as Modals from "../modalsTypes";

const initialState = {
  window: null, //Modals.LB_BORROW
  data: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Modals.LB_LEND: {
      return { ...state, window: Modals.LB_LEND, data: action.payload };
    }
    case Modals.LB_BORROW: {
      return { ...state, window: Modals.LB_BORROW, data: action.payload };
    }
    case Modals.WALLET_CONFIRM: {
      return { ...state, window: Modals.WALLET_CONFIRM, data: action.payload };
    }
    case Modals.CONFIRM: {
      return { ...state, window: Modals.CONFIRM, data: action.payload };
    }
    case Modals.FARM_CLAIM: {
      return { ...state, window: Modals.FARM_CLAIM, data: action.payload };
    }
    case Modals.FARM_PAGE: {
      return { ...state, window: Modals.FARM_PAGE, data: action.payload };
    }
    case Modals.FARM_PAGE_COHORT: {
      return {
        ...state,
        window: Modals.FARM_PAGE_COHORT,
        data: action.payload,
      };
    }
    case Modals.FARM_DW: {
      return { ...state, window: Modals.FARM_DW, data: action.payload };
    }
    case Modals.APPROVE: {
      return { ...state, window: Modals.APPROVE, data: action.payload };
    }
    case Modals.MAX: {
      return { ...state, window: Modals.MAX, data: action.payload };
    }

    case Modals.CONNECT_WALLET: {
      return { ...state, window: Modals.CONNECT_WALLET, data: action.payload };
    }

    case Modals.APPROVE_DEPOSIT: {
      return { ...state, window: Modals.APPROVE_DEPOSIT, data: action.payload };
    }
    case Modals.REMOVE_LIQUIDITY: {
      return {
        ...state,
        window: Modals.REMOVE_LIQUIDITY,
        data: action.payload,
      };
    }
    case Modals.SWAP_SUPPLY: {
      return { ...state, window: Modals.SWAP_SUPPLY };
    }
    case Modals.CLOSE_POPUP: {
      return { ...state, window: null, data: null };
    }
    case Modals.BUY: {
      return { ...state, window: Modals.BUY };
    }
    default: {
      return state;
    }
  }
}
